import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<g clip-path=\"url(#clip0_94_7907)\"><path d=\"M2.617 15.924C2.43431 15.8483 2.27819 15.72 2.16837 15.5556C2.05854 15.3911 1.99995 15.1978 2 15V8H4V12.586L6.293 10.293C6.48049 10.1055 6.73481 10.0001 7 10H14V4H8V2H15C15.2652 2 15.5196 2.10536 15.7071 2.29289C15.8946 2.48043 16 2.73478 16 3V11C16 11.2652 15.8946 11.5196 15.7071 11.7071C15.5196 11.8946 15.2652 12 15 12H7.414L3.707 15.707C3.56716 15.8469 3.38895 15.9422 3.19492 15.9809C3.0009 16.0195 2.79977 15.9997 2.617 15.924Z\" fill=\"currentColor\"></path><path d=\"M6 2H4V0H2V2H0V4H2V6H4V4H6V2Z\" fill=\"currentColor\"></path></g><defs><clipPath id=\"clip0_94_7907\"><rect width=\"16\" height=\"16\" fill=\"white\"></rect></clipPath></defs>", 2)
const _hoisted_4 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }